import RootState from 'typings/RootState'
import { HistoryActivity, ReportEvent } from './types'

export const selectData = (state: RootState): HistoryActivity[] =>
  state.mainconHistory.data

export const selectEvent = (state: RootState): ReportEvent =>
  state.mainconHistory.event
